import React from 'react';
import PropTypes from 'prop-types';
import css from './SidebarCard.module.scss';

const SidebarCard = ({
  variant = 'primary',
  icon,
  title,
  description,
  onClick,
  collapsedContent,
  isCollapsed = false,
  className = '',
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  if (isCollapsed && collapsedContent) {
    return (
      <div
        className={`${css.sidebarCardCollapsed} ${css[variant]} ${className}`}
        onClick={handleClick}
      >
        {collapsedContent}
      </div>
    );
  }

  return (
    <div
      className={`${css.sidebarCard} ${css[variant]} ${className}`}
      onClick={handleClick}
    >
      <div className={css.content}>
        <h6 className={css.mainText}>
          {icon}
          {title}
        </h6>
        {description &&
          <div className={css.description}>
            {description}
          </div>
        }
      </div>
    </div>
  );
};

SidebarCard.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary']),
  icon: PropTypes.node,
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  onClick: PropTypes.func,
  collapsedContent: PropTypes.node,
  isCollapsed: PropTypes.bool,
  className: PropTypes.string,
};

export default SidebarCard;

